import { render } from "./InstancePicker.vue?vue&type=template&id=0bd6cd49"
import script from "./InstancePicker.vue?vue&type=script&lang=js"
export * from "./InstancePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__